import { makeStyles } from 'tss-react/mui';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles()((theme) => ({
  tabs: {
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'auto',
  },
  strikeText: {
    textDecoration: 'line-through',
  },
}));
